import { any, both, complement, isNil, isEmpty } from 'ramda'

export const notNil = complement(isNil)
export const notEmpty = complement(isEmpty)
export const hasValue = both(notNil, notEmpty)
export const hasOneValue = any(hasValue)
